import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';
import { GetAccountInfoResponse } from '@hud/portal-dtos/webapp-common.dto';
import { PORTAL_BASE } from '../consts';

export const ACCOUNT_INFO = 'AccountInfo';

export default function useAccountInfo() {
  const { client, isReady } = useClient();
  return useQuery({
    queryKey: [ACCOUNT_INFO],
    queryFn: async () => {
      const response = await client.get<GetAccountInfoResponse>(
        `${PORTAL_BASE}/account/info`,
      );
      return GetAccountInfoResponse.parse(response.data);
    },
    enabled: isReady,
  });
}
